import React from "react"
import PostSurveyForm from "./PostSurveyForm"

const FormSuccess = ({ title, survey, children }) => (
  <div className="success-form">
    <div className="success-icon">
      <svg xmlns="http://www.w3.org/2000/svg" height="32" viewBox="0 -960 960 960" width="32" fill="#ffffff">
        <path d="M382-240 154-468l57-57 171 171 367-367 57 57-424 424Z"/>
      </svg>
    </div>
    <div className="success-text">
      <span className="success-message">{title}</span>
      { children }
    </div>
    { survey ? <PostSurveyForm survey={survey}/> : null }
  </div>
)

export default FormSuccess